import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SeoService {
  constructor(private http: HttpClient) { }

  find(query: string, limit = 10) {
    return this.http.get<any[]>(environment.app.apiUrl + 'seo/find/' + query + '/' + limit).toPromise();
  }

  analyse(query: string, limit = 10) {
    return this.http.get<any>(environment.app.apiUrl + 'seo/analyse/' + query + '/' + limit).toPromise();
  }
}
